import InfoTooltip from "components/Popup/InfoTooltip";
import ConcreteBaseItemSelectCreate from "Dashboard/scenes/ConcreteBase/scenes/Input/components/ConcreteBaseItemSelectCreate";
import { IConcreteBaseFinancials } from "Dashboard/scenes/Projects/domain/IConcreteBaseFinancials";
import { FormatDateShort } from "utils/dateUtils";
import { FormatNumber, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { styles } from "./SelectStatisticsStyle";
import { useAppDispatch } from "hooks/hooks";
import { getProjectConcreteBaseFinancials, selectState } from "../financials.slice";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

interface IProps {
  data: IConcreteBaseFinancials | undefined;
  projectId: number;
};

const ConcreteBaseOwnProducts = ({ data, projectId }: IProps) => {
  const dispatch = useAppDispatch();

  const { selectedDateFrom, selectedDateTo } = useSelector(selectState);
  const [itemId, setItemId] = useState();

  useEffect(() => {
    if (projectId) {
      setItemId(undefined);
    }
  }, [projectId]);

  useEffect(() => {
    const abortCtrl = new AbortController();
    if (projectId) {
      dispatch(getProjectConcreteBaseFinancials({
        data: {
          projectId,
          from: selectedDateFrom,
          to: selectedDateTo,
          concreteBaseItemId: itemId
        },
        signal: abortCtrl.signal
      }));
    }
    return () => {
      if (projectId) {
        abortCtrl.abort();
      }
    };
  }, [
    dispatch,
    projectId,
    selectedDateFrom,
    selectedDateTo,
    itemId
  ]);

  return (
    <div>
      <h3><strong>BETON</strong></h3>
      <section>
        <div className="projects-box-header concrete-base-box">
          <div>
            <span className="right-align">suma</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.concreteQuantityTotal, 'm3')}
            </span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.costAmountTotal, 'rsd')}
            </span>
          </div>
          <div>
            <span className="right-align">projekti</span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.concreteQuantityProjects, 'm3')}
            </span>
            <span className="strong-txt center-align txt-underline">
              {FormatNumberWithUnitOrNull(data?.costAmountProjects, 'rsd')}
            </span>
          </div>
        </div>
        <div style={{ marginRight: "15px" }}>
          <ConcreteBaseItemSelectCreate
            key={projectId}
            onChange={setItemId}
            customStyles={styles.customStyleClassic}
          />
        </div>
        <div className="projects-box-content">
          <div className="list-wrapp">
            {data?.entries &&
              data.entries.map((entry, index) => (
                <article key={index}>
                  <div className="col-1">
                    <span className="left strong">{entry.itemName}</span>
                  </div>
                  <div>
                    <span className="box-span right">
                      {entry.quantityAmount} {entry.quantityUnit.name}
                    </span>
                    <span className="light-color">izdato</span>
                    <span className="box-span">
                      {FormatDateShort(entry.date)}
                    </span>
                  </div>
                  <div>
                    <span className="box-span right">
                      {FormatNumber(entry.pricePerUnit)} rsd
                    </span>
                    <InfoTooltip
                      tooltip={entry.note}
                      classesProp="light-color grid-span-2 bg-text-overflow"
                      element="span"
                    >
                      cena &nbsp;&nbsp; {entry.note}
                    </InfoTooltip>
                  </div>
                </article>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ConcreteBaseOwnProducts;
